import { GET_LOGIN } from "@/repositories/api/auth/getLogin";
import { GET_REFRESH } from "@/repositories/api/auth/getRefresh";

export const AuthWs = {
    GET_LOGIN,
    GET_REFRESH
};
